import { isSafeColor } from '../../utils/validation';

interface SafeColorDivProps {
  color?: string | null;
  className?: string;
  fallbackColor?: string;
}

/**
 * A div component that safely renders a background color from untrusted sources
 * Prevents XSS attacks via CSS injection in inline styles
 */
export function SafeColorDiv({ color, className = '', fallbackColor = '#6B7280' }: SafeColorDivProps) {
  const safeColor = color && isSafeColor(color) ? color : fallbackColor;

  return (
    <div
      className={className}
      style={{ backgroundColor: safeColor }}
    />
  );
}

interface SafeColorBadgeProps {
  color?: string | null;
  label: string;
  className?: string;
}

/**
 * A badge component with a safe color indicator
 */
export function SafeColorBadge({ color, label, className = '' }: SafeColorBadgeProps) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <SafeColorDiv
        color={color}
        className="w-2.5 h-2.5 rounded-full shrink-0"
      />
      <span>{label}</span>
    </div>
  );
}
